"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@as-react/common-utils");
const keysToFilter = ['directCallRule'];
const AdobeTagManager = (options = {}) => events => {
    const dataLayerName = (options.dataLayerName || 'digitalData');
    const directCallLayerName = (options.directCallLayerName || '_satellite');
    const enableDebug = options.enableDebug || false;
    if (typeof window === 'undefined') {
        return;
    }
    if (!window[dataLayerName]) {
        console.warn(`redux-beacon error: window.${dataLayerName} is not defined. Have you forgotten to include Adobe Tag Manager and dataLayer?`);
        return;
    }
    if (!window[directCallLayerName] || !window[directCallLayerName].track) {
        console.warn(`redux-beacon error: window.${directCallLayerName} is not defined. Have you forgotten to include Adobe Tag Manager and dataLayer?`);
        return;
    }
    const logger = (...args) => enableDebug && console.debug('🚀 [Redux Beacon]', ...args);
    try {
        events.forEach(rawEvent => {
            var _a, _b, _c;
            const dataLayer = window[dataLayerName];
            const directCallLayer = window[directCallLayerName];
            let directCallRules = [];
            if (rawEvent.directCallRule) {
                directCallRules = [...directCallRules, rawEvent.directCallRule];
            }
            logger('directCallRules', directCallRules);
            if (rawEvent.event) {
                directCallRules = [
                    ...directCallRules,
                    ...rawEvent.event
                        .filter((filterEvent) => !(0, common_utils_1.isNullOrUndefined)(filterEvent.eventInfo) &&
                        !(0, common_utils_1.isNullOrUndefined)(filterEvent.eventInfo.directCallRule) &&
                        filterEvent.eventInfo.directCallRule === true)
                        .map((filterEvent) => filterEvent.eventInfo.ruleName),
                ].filter(Boolean);
                logger('directCallRules after merge', directCallRules);
            }
            const event = Object.keys(rawEvent)
                .filter(key => keysToFilter.indexOf(key) === -1)
                .reduce((obj, key) => (Object.assign(Object.assign({}, obj), { [key]: rawEvent[key] })), {});
            if (event.type !== undefined) {
                switch (event.type) {
                    case 'event':
                        dataLayer.event.push(event.payload);
                        console.debug('Added event to dataLayer', JSON.stringify(dataLayer.event));
                        break;
                    default:
                        break;
                }
            }
            else {
                logger('Original dataLayer', dataLayer);
                logger('To merge event', event);
                if (((_a = dataLayer.product) === null || _a === void 0 ? void 0 : _a.length) && event.product) {
                    dataLayer.product = [];
                }
                if (((_b = dataLayer.additionalProduct) === null || _b === void 0 ? void 0 : _b.length) && event.additionalProduct) {
                    dataLayer.additionalProduct = [];
                }
                if (((_c = dataLayer.bundleProduct) === null || _c === void 0 ? void 0 : _c.length) && event.bundleProduct) {
                    dataLayer.bundleProduct = [];
                }
                const digitalDataObject = (0, common_utils_1.mergeObjectDeep)(dataLayer, event);
                logger('Merged digitalDataObject', digitalDataObject);
                window[dataLayerName] = digitalDataObject;
                logger('After set', window[dataLayerName]);
            }
            if (directCallRules.length > 0 && directCallLayer) {
                directCallRules.forEach(directCallRule => {
                    directCallLayer.track(directCallRule);
                    logger(`track DirectcallRule: ${directCallRule}`);
                });
            }
        });
    }
    catch (e) {
        console.error('redux-beacon error in scripts', e);
    }
};
exports.default = AdobeTagManager;
//# sourceMappingURL=adobe-tag-manager.js.map